














import Vue from "vue";
import { mapActions } from "vuex";
import { ChartActTypes } from "@/core/stores/modules/chart.store";

export default Vue.extend({
  name: "RepostList",
  props: ["reportList"],
  watch: {
    reportList(newValue, oldValue) {
      if (newValue.length && newValue !== oldValue) {
        this.getDataByCode(
          this.reportList[0].code,
          this.reportList[0].requireFilter
        );
      }
    },
  },
  methods: {
    ...mapActions({
      getData: ChartActTypes.FETCH_DATA,
    }),
    getDataByCode(
      code: string,
      requireFilter: boolean,
      startDate?: string,
      endDate?: string
    ) {
      this.getData({ code, requireFilter });
    },
  },
});
